/**
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import ServicePath from "@/core/ServicePath";
import { MainRequest } from "@/core/request";

export default class ProcedureApplicationRequest extends MainRequest {

    static addProcedureApplication(data){
        return this.postSEC(ServicePath.PROCEDURE_APPLICATION_ADD, data)
    }

    static listAllByMedical(data){
        return this.postSEC(ServicePath.PROCEDURE_APPLICATION_LIST_BY_MEDICAL, data)
    }

    static updateProcedureApplication(data){
        return this.postSEC(ServicePath.PROCEDURE_APPLICATION_UPDATE, data)
    }

}